export default "__VITE_ASSET__CskQ0_iZ__"